import request from "../http/request";

export function leftTopData1(data) {
    return request({
        method:'post',
        url:`${process.env.VUE_APP_BASE_API}/trademark_all/service/data/getTrademarkAreaData`,
        data
    })
}

export function leftTopData(data) {
    return request({
        method:'post',
        url:`${process.env.VUE_APP_BASE_API}/trademark_all/service/data/getTrademarkAreaDataMap`,
        data
    })
}

export function leftCenterData(data) {
    return request({
        method:'post',
        url:`${process.env.VUE_APP_BASE_API}/trademark_all/service/data/getEnterpriseData`,
        data
    })
}

//   行业分布top5的信息
export function leftBottomData(data) {
    return request({
        method:'post',
        url:`${process.env.VUE_APP_BASE_API}/trademark_all/service/data/getTrademarkTradeData`,
        data
    })
}

//   产业分布柱状图top5
export function rightTopData(data) {
    return request({
        method:'post',
        url:`${process.env.VUE_APP_BASE_API}/trademark_all/service/data/getIndustryTopData`,
        data
    })
}


//     商标类别柱状图
export function rightCenterData(data) {
    return request({
        method:'post',
        url:`${process.env.VUE_APP_BASE_API}/trademark_all/service/data/getTrademarkCategoryData`,
        data
    })
}

//     商标类别柱状图
export function rightCenterData2(data) {
    return request({
        method:'post',
        url:`${process.env.VUE_APP_BASE_API}/trademark_all/service/data/getTrademarkCategoryDataTwo`,
        data
    })
}

//        企业商标数量top5
export function rightTopBottomData(data) {
    return request({
        method:'post',
        url:`${process.env.VUE_APP_BASE_API}/trademark_all/service/data/getEnterpriseTrademarkTopData`,
        data
    })
}

//        企业商标数量top5
export function centerData(data) {
    return request({
        method:'post',
        url:`${process.env.VUE_APP_BASE_API}/trademark_all/service/data/getCenterNewData`,
        data
    })
}

//     总的商标数量和申请量
// export function centerTopData(data) {
//     return request({
//         method:'post',
//         url:`${process.env.VUE_APP_BASE_API}/trademark_all/service/data/getTrademarkCenterSumData`,
//         data
//     })
// }

export function getTrademarkTendencyChart(data) {
    return request({
        method:'post',
        url:`${process.env.VUE_APP_BASE_API}/trademark_all/service/data/getTrademarkTendencyChart`,
        data
    })
}

export function getTrademarkUpdateTim(data = {}) {
    return request({
        method:'post',
        url:`${process.env.VUE_APP_BASE_API}/trademark_all/service/data/getTrademarkUpdateTime`,
        data
    })
}

export function getDataAnalysisYear(data = {}) {
    return request({
        method:'post',
        url:`${process.env.VUE_APP_BASE_API}/trademark_all/service/data/getDataAnalysisYear`,
        data
    })
}

export function getGeojson(data) {
    return request({
        method:'post',
        url:`${process.env.VUE_APP_BASE_API}/trademark_all/service/data/getGaoDeMapData`,
        data
    })
}

export function getEnterpriseDataDetailTwo(data) {
    return request({
        method:'post',
        url:`${process.env.VUE_APP_BASE_API}/trademark_all/service/data/getEnterpriseDataDetailTwo`,
        data
    })
}

export function getEnterpriseDataDetailThree(data) {
    return request({
        method:'post',
        url:`${process.env.VUE_APP_BASE_API}/trademark_all/service/data/getEnterpriseDataDetailThree`,
        data
    })
}

export function getTrademarkTradeDataThree(data) {
    return request({
        method:'post',
        url:`${process.env.VUE_APP_BASE_API}/trademark_all/service/data/getTrademarkTradeDataThree`,
        data
    })
}

export function getTrademarkAreaDataThree(data) {
    return request({
        method:'post',
        url:`${process.env.VUE_APP_BASE_API}/trademark_all/service/data/getTrademarkAreaDataDetail`,
        data
    })
}

export function getTrademarkCategoryDataThree(data) {
    return request({
        method:'post',
        url:`${process.env.VUE_APP_BASE_API}/trademark_all/service/data/getTrademarkCategoryDataThree`,
        data
    })
}

export function getApplicantTrademark(data) {
    return request({
        method:'post',
        url:`${process.env.VUE_APP_BASE_API}/trademark_all/service/data/getApplicantTrademark`,
        data
    })
}
